import { SET_SETTINGS } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getSettings = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/settings`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_SETTINGS, payload: response.data.settings });
    }
    catch (error) { errorHandler(error, null); }
};

export const editSettings = (formValues, onSuccess, onFieldError) => async () => {
    try {
        const response = await backend.patch(`/api/settings`, { ...formValues }, {
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${store.getState().auth.token || ""}`
            }
        });
        
        if (response) onSuccess();
    }
    catch (error) { errorHandler(error, onFieldError); }
};